import React, { useState, useEffect } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { ExerciseType } from './types';

/**
 * Editor para exercícios do tipo Texto Formatado
 */
export const FormattedTextEditor: React.FC<{
  onChange: (data: {
    content: string;
  }) => void;
  initialData?: {
    content: string;
    type?: ExerciseType;
  };
  type?: ExerciseType;
}> = ({ onChange, initialData }) => {
  const [content, setContent] = useState("");

  // useEffect para carregar dados iniciais quando initialData muda
  useEffect(() => {
    console.log('FormattedTextEditor: initialData changed:', initialData);
    if (initialData) {
      setContent(initialData.content || "");
    } else {
      // Reset quando initialData é undefined (novo exercício)
      setContent("");
    }
  }, [initialData]);

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(e.target.value);
    onChange({ content: e.target.value });
  };

  return (
    <div className="space-y-4">
      {/* Campo de conteúdo */}
      <div className="space-y-2">
        <Label htmlFor="formatted-text-content">Conteúdo (suporta Markdown)</Label>
        <Textarea
          id="formatted-text-content"
          placeholder="Digite o conteúdo do texto formatado"
          value={content}
          onChange={handleContentChange}
          rows={8}
          className="min-h-[200px]"
        />
        <p className="text-xs text-gray-500">
          Você pode usar markdown para formatação: **negrito**, *itálico*, [link](url), etc.
        </p>
      </div>
    </div>
  );
}; 